'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.core.forms.cbSubmit', []);

_module.directive('cbSubmit', cbSubmit);

exports.default = _module;

/**
 * cb-submit
 *
 * ng-submit only works for <form>s with [type="submit"] elements.
 * It doesn't work for <div ng-form>s. When using the latter (e.g., on
 * SharePoint, you can't use <form> tags), use cb-submit to emulate correct
 * behavior.
 *
 * See also: https://github.com/angular/angular.js/issues/2513
 *
 * @param {String} code to be executed
 */

function cbSubmit() {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            // Handle submit invoked by pressing [type="submit"] button.
            element.find(jQuery('[type=submit]')).on('click', function (e) {
                e.preventDefault();
                scope.$apply(function () {
                    scope.$eval(attrs.cbSubmit, {
                        'event': e
                    });
                });
            });

            // Handle submit invoked by pressing Enter on an input field.
            element.bind('keydown keypress', function (e) {
                if (e.which === 13) {

                    // trigger blur event
                    // current element + enter doesn't trigger any validation
                    _angular2.default.element(e.target).trigger('blur');

                    scope.$apply(function () {
                        scope.$eval(attrs.cbSubmit, {
                            'event': e
                        });
                    });
                    e.preventDefault();
                }
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/cb-submit.directive.js
// module id = 778
// module chunks = 0